import { customAlphabet } from 'nanoid/non-secure';

const nonce = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyz', 26);

/** One per tap on start, so a retried request is recognized. */
export function newApdmImportRequestKey(): string {
  return 'apreq_' + nonce();
}
